/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Title,
  Select,
  GoBack,
  TextArea,
  MyMessage,
  InputField,
  PhoneInput,
  MyActionButton,
  SelectInput,
} from "../../component/Component";
import { codeOk, errorMessage } from "../../../../middlewares/index";
import { useCountryContext } from "../../../../context/country/countryContext/CountryContext";
import { useTourPackageContext } from "../../../../context/tourPackage/TourPackageContext";
import { useAgentContext } from "../../../../context/agent/AgentContext";
import { getOneAgent } from "../../../../middlewares/sysNavigation/SysNavigation";
import { ImageKitUpload } from "../../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { FOLDERS, image_kit_folder } from "../../../doseeData/utils/Utils";
import { defaultImage } from "../../../../middlewares/libraries/imageKit/ImageKit";

const Edit = () => {
  const { updateAgent, updateAgentState } = useAgentContext();
  const { countries, fetchCountries } = useCountryContext();
  const { tourPackages, fetchTourPackages } = useTourPackageContext();

  const _agent_ = getOneAgent();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const dsa_agents_id = _agent_.dsa_agents_id;

  const [title, setTitle] = useState(_agent_.name);
  const [country_name, setCountryName] = useState(_agent_.country);
  const [agent_package_id, setAgentPackageId] = useState(_agent_.agent_package_id);
  const [agent_payment_id, setAgentPaymentId] = useState(_agent_.agent_payment_id);
  const [agent_email, setAgentEmail] = useState(_agent_.email_address);
  const [agent_phone, setAgentPhone] = useState(_agent_.phonenumber);
  const [agent_contact, setAgentContact] = useState(_agent_.contact_person_name);
  const [agent_transactions, setAgentTransactions] = useState(_agent_.number_of_transaction);
  const [agent_rating, setAgentRating] = useState(_agent_.rating);
  const [description, setDescription] = useState(_agent_.description);

  const [thumbnail, setThumbnail] = useState(_agent_?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState(_agent_?.image_cdn_id);
  const [thumbnailLogo, setThumbnailLogo] = useState(_agent_?.logo);
  const [thumbnailIdLogo, setThumbnailIdLogo] = useState(_agent_?.logo_ref_id);

  const [tourName, setTourName] = useState(null);

  const agentRoutes = "/agent";

  useEffect(() => {
    if (!countries) fetchCountries();
    if (!tourPackages) fetchTourPackages();
    if (!tourName && tourPackages && agent_package_id) {
      setTourName(tourPackages.find((x) => (x.tour_package_id = agent_package_id))?.title);
    }
  }, [countries, tourPackages, _agent_, tourName]);

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
  };

  const responses = (isError, message) => {
    setLoading(false);
    setError(isError);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const addOneAgentHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId || !thumbnailLogo || !thumbnailIdLogo) {
      setLoading(false);
      return responses(true, "Image or Logo Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      agent_package_id: agent_package_id,
      agent_payment_id: agent_payment_id,
      agent_biz_reg_no: title?.replace(/ /g, "-") || "reg-no-agent",
      logo: thumbnailLogo ? thumbnailLogo : defaultImage,
      logo_ref_id: thumbnailIdLogo,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      email_address: agent_email,
      phonenumber: agent_phone,
      contact_person_name: agent_contact,
      country: country_name ? country_name : "Uganda",
      number_of_transaction: agent_transactions,
      rating: agent_rating,
      name: title,
      description: description,
    };

    const response = await updateAgent(dsa_agents_id, data);
    if (response) {
      if (response.data.status === codeOk) {
        updateAgentState({ dsa_agents_id, ...data });
        cleanFields();
        return responses(false, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, errorMessage);
    }
  };

  const hasProfileImage = !!thumbnailId;
  const hasLogo = !!thumbnailIdLogo;

  return (
    <div className="h-full overflow-y-auto bg-gray-50 p-4 rounded-b-xl">
      <div className="mx-auto max-w-6xl">
        <GoBack props={{ route: agentRoutes }} />

        {/* Header / Intro */}
        <div className="relative mt-3 mb-5">
          <div className="pointer-events-none absolute -inset-x-6 -top-6 h-24 rounded-3xl bg-gradient-to-r from-emerald-400/15 via-amber-400/15 to-fuchsia-400/15 blur-2xl -z-10" />
          <div className="relative rounded-2xl border border-gray-200 bg-white/90 shadow-sm backdrop-blur">
            <div className="flex flex-col gap-4 p-5 md:flex-row md:items-center md:justify-between">
              <div>
                <h1 className="text-base font-semibold tracking-tight text-gray-900">
                  Edit Agent
                </h1>
                <p className="mt-0.5 text-xs text-gray-600">
                  Update brand assets, contact details and package information.
                </p>
              </div>
              <div className="flex flex-wrap items-center gap-2">
                <StatusChip label="Profile Image" ok={hasProfileImage} />
                <StatusChip label="Logo" ok={hasLogo} />
              </div>
            </div>
          </div>
        </div>

        <form onSubmit={addOneAgentHandler} className="space-y-5">
          <MyMessage
            error={error}
            message={message}
            success={success}
            onExpired={() => {
              setError(false);
              setSuccess(false);
            }}
            onClick={() => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            }}
          />

          {/* Brand Assets */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm p-4 md:p-5">
            <div className="mb-3 flex items-center justify-between">
              <Title props={{ title: "Brand Assets" }} />
              <span className="text-[11px] text-gray-500">JPEG/PNG — recommended square</span>
            </div>

            <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
              <div className="rounded-xl border border-dashed border-gray-200 p-3">
                <p className="mb-2 text-xs font-semibold text-gray-700">Agent Profile</p>
                <ImageKitUpload
                  thumbnail={thumbnail}
                  thumbnailId={thumbnailId}
                  setThumbnail={setThumbnail}
                  setThumbnailId={setThumbnailId}
                  folder={image_kit_folder("dosee", FOLDERS.AGENTS)}
                />
              </div>
              <div className="rounded-xl border border-dashed border-gray-200 p-3">
                <p className="mb-2 text-xs font-semibold text-gray-700">Agent Logo</p>
                <ImageKitUpload
                  thumbnail={thumbnailLogo}
                  thumbnailId={thumbnailIdLogo}
                  setThumbnail={setThumbnailLogo}
                  setThumbnailId={setThumbnailIdLogo}
                  folder={image_kit_folder("dosee", FOLDERS.AGENTS)}
                />
              </div>
            </div>
          </section>

          {/* Contact & Packages */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm p-4 md:p-5">
            <div className="mb-3">
              <Title props={{ title: "Contact & Packages" }} />
            </div>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
              <SelectInput
                title="Country"
                value={country_name}
                defaultValue={country_name}
                options={countries ? [...countries.map((country) => country.name)] : []}
                onChange={(e) => {
                  const index = e.target.selectedIndex;
                  setCountryName(countries[index].name);
                  setError(null);
                  setSuccess(null);
                }}
              />

              <SelectInput
                title="Tour Package"
                value={tourName}
                defaultValue={tourName}
                options={
                  tourPackages !== null ? [...tourPackages.map((tour) => tour.title)] : []
                }
                onChange={(e) => {
                  const index = e.target.selectedIndex;
                  setAgentPackageId(tourPackages[index]?.tour_package_id);
                  setError(null);
                  setSuccess(null);
                }}
              />

              {/* Retain the legacy Select (logic preserved) */}
              <Select
                props={{
                  id: "tour_package_id",
                  title: "Tour Package",
                  option:
                    tourPackages !== null
                      ? [...tourPackages.map((tour) => tour.title)]
                      : [],
                  onChange: (e) => {
                    const index = e.target.selectedIndex;
                    setAgentPackageId(tourPackages[index]?.id);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />

              <Select
                props={{
                  id: "agent_payment_id",
                  title: "Payment Method",
                  option: ["Visa", "Cash", "E-Wallet", "Mobile Money"],
                  onChange: (e) => {
                    const index = e.target.selectedIndex;
                    setAgentPaymentId(index);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </section>

          {/* Agent Details */}
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm p-4 md:p-5">
            <div className="mb-3">
              <Title props={{ title: "Agent Details" }} />
            </div>

            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
              <InputField
                props={{
                  id: "title",
                  title: "Name",
                  type: "text",
                  value: title ? title : "",
                  onChange: (e) => {
                    setTitle(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />

              <InputField
                props={{
                  id: "agent_email",
                  title: "Agent Email",
                  type: "text",
                  value: agent_email ? agent_email : "",
                  onChange: (e) => {
                    setAgentEmail(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />

              <PhoneInput setPhone={setAgentPhone} phone={agent_phone} required={true} />

              <InputField
                props={{
                  id: "agent_contact",
                  title: "Agent Contact Person",
                  type: "text",
                  value: agent_contact ? agent_contact : "",
                  onChange: (e) => {
                    setAgentContact(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />

              <InputField
                props={{
                  id: "agent_transaction",
                  title: "Agent Transactions",
                  type: "number",
                  value: agent_transactions ? agent_transactions : "",
                  onChange: (e) => {
                    setAgentTransactions(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />

              <InputField
                props={{
                  id: "agent_rating",
                  title: "Agent Rating",
                  type: "number",
                  value: agent_rating ? agent_rating : "",
                  onChange: (e) => {
                    setAgentRating(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>

            <div className="mt-4">
              <TextArea
                props={{
                  id: "description",
                  title: "Description",
                  type: "text",
                  value: description ? description : "",
                  onChange: (e) => {
                    setDescription(e.target.value);
                    setError(null);
                    setSuccess(null);
                  },
                }}
              />
            </div>
          </section>

          {/* Action */}
          <div className="flex items-center justify-end w-full">
            <div className="flex justify-center items-center rounded-xl bg-white shadow-sm ring-1 ring-gray-200 p-2 w-full">
              <MyActionButton
                className="min-w-[200px]"
                title="Update Profile"
                loading={loading}
                onClick={() => {
                  setError(false);
                  setSuccess(false);
                  setErrorMessage(null);
                }}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Edit;

const StatusChip = ({ label, ok }) => {
  return (
    <span
      className={[
        "inline-flex items-center gap-2 rounded-full px-2.5 py-1 text-[11px] font-medium ring-1",
        ok
          ? "bg-emerald-50 text-emerald-700 ring-emerald-200"
          : "bg-gray-50 text-gray-600 ring-gray-200",
      ].join(" ")}
    >
      <span
        className={["h-1.5 w-1.5 rounded-full", ok ? "bg-emerald-500" : "bg-gray-300"].join(" ")}
      />
      {label}
    </span>
  );
};
